import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDateToMonthDayYear } from '@repo/common';

const MyQnaRow = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      className='flex flex-col p-3 tabletH:p-6 items-start justify-center gap-3 tabletH:gap-5 bg-grayscale-gray00 border border-grayscale-gray02
                 rounded-lg cursor-pointer min-h-[102px]'
      onClick={() => navigate(`/community/qna/${item.qnaId}`)}
    >
      <div
        className={`flex gap-3 tabletH:gap-6 ${
          item.answerContent ? 'items-center' : 'items-start'
        } justify-center`}
      >
        <div
          className='size-8 flex flex-col pt-[10px] pl-[11px] pr-3 pb-[9px] justify-center items-center gap-2.5
         rounded-[20px] bg-grayscale-gray09 text-grayscale-gray02 typo-b16Strong'
        >
          Q
        </div>
        <div
          className={`flex flex-col ${
            item.answerContent ? 'items-center' : 'items-start gap-3'
          }`}
        >
          <div className='line-clamp-2 typo-b14 tabletH:typo-b16'>
            {item.title}
          </div>
          <div>
            {!item.answerContent && (
              <div className='typo-b12 tabletH:typo-b13 text-text-placeholder'>
                {item.categoryName} ·{' '}
                {formatDateToMonthDayYear(item.qnaCreatedAt)}
              </div>
            )}
          </div>
        </div>
      </div>

      {item.answerContent && (
        <>
          <div className='w-full border-b border-b-grayscale-gray02' />

          <div className='flex gap-3 tabletH:gap-6 items-start justify-center w-full min-w-0'>
            <div
              className='size-8 flex pt-[10px] pl-[11px] pr-3 pb-[9px] justify-center items-center gap-2.5
                rounded-[20px] bg-grayscale-gray02 text-grayscale-gray07 typo-b16Strong'
            >
              A
            </div>
            <div className='flex flex-col gap-3 min-w-0 flex-1'>
              <div className='text-text-primary line-clamp-3 break-words typo-b14 tabletH:typo-b16'>
                {item.answerContent}
              </div>
              <div className='typo-b12 tabletH:typo-b13 text-text-placeholder'>
                {item.categoryName} ·{' '}
                {formatDateToMonthDayYear(item.qnaCreatedAt)}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MyQnaRow;
